'use client'

import { type ReactNode } from 'react'

interface ChatTemplateProps {
	children: ReactNode
	/** Input area slot (pinned to bottom) */
	inputArea?: ReactNode
	/** Header slot (e.g., conversation title) */
	header?: ReactNode
}

/**
 * Template for full-height chat pages.
 * Messages area fills available space, input pinned to bottom.
 */
export function ChatTemplate({ children, inputArea, header }: ChatTemplateProps) {
	return (
		<div className="flex h-svh w-full flex-col overflow-hidden">
			{header && (
				<div className="border-brand-border bg-brand-surface/80 shrink-0 border-b backdrop-blur-sm">
					{header}
				</div>
			)}
			<div className="flex-1 overflow-y-auto">{children}</div>
			{inputArea && (
				<div className="border-brand-border bg-brand-surface/80 shrink-0 border-t p-4 backdrop-blur-sm">
					{inputArea}
				</div>
			)}
		</div>
	)
}
